import React from "react";
import ReactApexChart from "react-apexcharts";
import { useTitle } from "../../../../hooks/useTitle";
import { withAuth } from "../../../../components/HOC/withAuth";
import CardContainer from "../../../../components/CustomUI/CardContainer";
import { SectionSpinner, SectionEmpty } from "../shared/utils";
import DowntimeReportShell from "./DowntimeReportShell";
import { useDowntimeReport } from "./useDowntimeReport";

const DowntimeTrendReport = () => {
  useTitle("Rovion MES - Özet Raporu");
  const {
    filters,
    machines,
    shifts,
    stopLogs,
    loading,
    derived,
    fetchData,
    toasts,
    dismissToast,
  } = useDowntimeReport();

  const content = () => {
    if (loading) return <SectionSpinner />;
    if (!stopLogs.length || !derived) return <SectionEmpty />;
    const { dayMap, dayKeys, dayCountMap } = derived;
    if (dayKeys.length < 2)
      return <SectionEmpty msg="Trend için yeterli veri yok." />;

    return (
      <CardContainer title="Özet Raporu">
        <ReactApexChart
          type="line"
          series={[
            {
              name: "Süre (dk)",
              type: "column",
              data: dayKeys.map((d) => dayMap[d] || 0),
            },
            {
              name: "Duruş Sayısı",
              type: "line",
              data: dayKeys.map((d) => dayCountMap[d] || 0),
            },
          ]}
          options={{
            chart: {
              type: "line",
              toolbar: { show: false },
              fontFamily: "inherit",
              foreColor: "#334155",
            },
            colors: ["#e74c3c", "#3498db"],
            stroke: { width: [0, 2] },
            plotOptions: { bar: { columnWidth: "70%", borderRadius: 3 } },
            xaxis: {
              categories: dayKeys,
              labels: { rotate: -45, style: { fontSize: "10px" } },
            },
            yaxis: [
              {
                title: { text: "Süre (dk)" },
                labels: { formatter: (v) => Math.round(v) },
              },
              {
                opposite: true,
                title: { text: "Sayı" },
                labels: { formatter: (v) => Math.round(v) },
              },
            ],
            legend: { position: "top" },
            dataLabels: { enabled: false },
            grid: { borderColor: "#f0f2f5" },
            tooltip: { shared: true, intersect: false },
          }}
          height={280}
        />
      </CardContainer>
    );
  };

  return (
    <DowntimeReportShell
      title="Özet Raporu"
      filters={filters}
      machines={machines}
      shifts={shifts}
      onApply={fetchData}
      toasts={toasts}
      dismissToast={dismissToast}
    >
      {content()}
    </DowntimeReportShell>
  );
};

export default withAuth(DowntimeTrendReport);
